
import { getProductByID, toRollerShutter } from 'modules/shop-front/shop-front-component/ProductCollection'
import GenericProductPage from '../GenericProductPage'
export default function RS55mmDL() {

    return (
        GenericProductPage(getProductByID(63),toRollerShutter)
    )
  }
